import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app';
import Dashboard from '@/components/Dashboard'
import Profile from '@/components/Profile'
import Login from '@/components/Login'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    next({ name: 'Login'});
  // else if (!requiresAuth && currentUser) next('Dashboard')
  } else { next() 

  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js